module.exports = __webpack_public_path__ + "static/author-9f6fc3b2207797c18d0f131850e86992.png";